import React, { useEffect, useState } from 'react';
import AOS from 'aos';

export default function Book() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const res = await fetch('https://sanjaydhir.com/api/books');
        const data = await res.json();
        setBooks(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to load books:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  useEffect(() => {
    if (!loading && books.length > 0) {
      setTimeout(() => {
        AOS.refreshHard();
      }, 150);
    }
  }, [loading, books]);

  return (
    <div className="container py-5 my-3 text-light">
      <div className="text-center mb-5" data-aos="fade-down">
        <h1 className="fw-bold text-gradient display-5">Books & Monographs</h1>
        <p className="text-secondary mx-auto" style={{ maxWidth: '600px' }}>
          Authored, co-authored, and edited books in Strategic Management, Innovation, and Flexible Systems.
        </p>
      </div>

      {loading ? (
        <div className="text-center text-secondary py-5">
          <div className="spinner-border text-info mb-2" role="status"></div>
          <div>Loading published books...</div>
        </div>
      ) : books.length === 0 ? (
        <div className="text-center text-secondary py-5">
          No books published yet. Check back soon.
        </div>
      ) : (
        <div className="row g-4 justify-content-center">
          {books.map((book, idx) => {
            const cover =
              book.coverImage ||
              'https://via.placeholder.com/350x500/1e293b/38bdf8?text=Book+Cover';

            return (
              <div
                key={book._id}
                className="col-12 col-sm-6 col-lg-4"
                data-aos="fade-up"
                data-aos-delay={idx * 150}
              >
                <div
                  className="card h-100 bg-dark text-light border-secondary shadow-lg d-flex flex-column overflow-hidden"
                  style={{
                    borderRadius: '12px',
                    transition: 'transform 0.25s ease, border-color 0.25s ease',
                    background: 'linear-gradient(180deg, #1e293b 0%, #0f172a 100%)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-6px)';
                    e.currentTarget.style.borderColor = '#38bdf8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#475569';
                  }}
                >
                  {/* Book Cover */}
                  <div
                    style={{
                      height: '280px',
                      width: '100%',
                      background: '#0a0f1d',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      padding: '12px',
                    }}
                  >
                    <img
                      src={cover}
                      alt={book.title}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        borderRadius: '6px',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.5)',
                      }}
                    />
                  </div>

                  {/* Card Details */}
                  <div className="card-body d-flex flex-column p-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="badge bg-info bg-opacity-25 text-info px-2 py-1">
                        {book.year}
                      </span>
                      {book.isbn && (
                        <span className="text-secondary small">ISBN: {book.isbn}</span>
                      )}
                    </div>

                    <h5 className="card-title fw-bold text-white mb-2">{book.title}</h5>
                    <p className="text-info small mb-1">{book.authors}</p>
                    <p className="text-secondary small mb-3">
                      <em>{book.publisher}</em>
                    </p>

                    {book.description && (
                      <p
                        className="text-light small flex-grow-1"
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {book.description}
                      </p>
                    )}

                    {book.buyLink && (
                      <a
                        href={book.buyLink}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-warning mt-3 w-100 rounded-pill"
                      >
                        Get Book / View Publisher ↗
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}